import { classNames } from "@NBCUDTC/reactjs-utility-belt/classnames";

import styles from "./LockedSash.module.scss";
import { LockedSashProps } from "./types";
import { Icon, StreamingIcons } from "../Icon";

/**
 * LockedSash component is used in the corner of tiles to indicate content the user is not entitled to.
 *
 * @param size - The size of the locked sash
 * @param className - Additional CSS class for styling
 * @param attr - Additional HTML attributes to pass to the rendered element
 *
 * @returns the rendered LockedSash component
 *
 * @example
 * ```tsx
 *  <LockedSash size = {LockedSashSize.Small} />
 * ```
 */
const LockedSash = ({ size, className, ...attr }: LockedSashProps) => {
  const cn = classNames(
    styles["locked-sash"],
    styles[`size-${size}`],
    className,
  );

  return (
    <div className={cn} {...attr}>
      <Icon className={styles["icon"]} icon={StreamingIcons.Lock}></Icon>
    </div>
  );
};

export { LockedSash };
